import router from './routes/routes'
import locales from './locales/locales'

export const FaqsModule = {
    name: "faqs",
    routes: router,
    locales: locales,
}